var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );




var shim = require("/var/www/django/adg.org/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/components/CommonVideoPlayer/CommonVideoPlayer.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/utils/macros.jinja", false, "assets/app/front/components/CommonVideoPlayer/CommonVideoPlayer.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("macros", t_1);
output += "\n\n";
var macro_t_4 = runtime.makeMacro(
[], 
["data", "delayed"], 
function (kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
frame.set("data", Object.prototype.hasOwnProperty.call(kwargs, "data") ? kwargs["data"] : {});frame.set("delayed", Object.prototype.hasOwnProperty.call(kwargs, "delayed") ? kwargs["delayed"] : 0);var t_5 = "";t_5 += "\n    <div class=\"CommonVideoPlayer\" data-provider=\"";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"provider"), env.opts.autoescape);
t_5 += "\" data-delayed=\"";
t_5 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "delayed"), env.opts.autoescape);
t_5 += "\">\n        ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"cover")) {
t_5 += "<div class=\"CommonVideoPlayer-preview\">\n            <img src=\"";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"cover")),"w920_url"), env.opts.autoescape);
t_5 += "\"\n              srcset=\"";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"cover")),"w1680_url"), env.opts.autoescape);
t_5 += " 1680w,\n                      ";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"cover")),"w920_url"), env.opts.autoescape);
t_5 += " 920w,\n                      ";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"cover")),"w680_url"), env.opts.autoescape);
t_5 += " 680w\"\n              sizes=\"(max-width: 759px) 1, ";
t_5 += "\n                     100vw\"\n              alt=\"\">\n        </div>\n        ";
;
}
t_5 += "\n\n        ";
if((runtime.contextOrFrameLookup(context, frame, "delayed"))) {
t_5 += "\n          <div class=\"CommonVideoPlayer-iframe\" data-code=\"";
t_5 += runtime.suppressValue(env.getFilter("tojson").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"code")), env.opts.autoescape);
t_5 += "\">\n          </div>\n        ";
;
}
else {
t_5 += "\n          <div class=\"CommonVideoPlayer-iframe\">\n              ";
t_5 += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"code")), env.opts.autoescape);
t_5 += "\n          </div>\n        ";
;
}
t_5 += "\n    </div>\n";
;
frame = callerFrame;
return new runtime.SafeString(t_5);
});
context.addExport("CommonVideoPlayer");
context.setVariable("CommonVideoPlayer", macro_t_4);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/components/CommonVideoPlayer/CommonVideoPlayer.jinja"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/CommonVideoPlayer/CommonVideoPlayer.jinja
// module id = 20
// module chunks = 0